<template>
    <div>
        <el-card shadow="hover">
            <el-button @click="handleEditOrCreate">添加角色</el-button>
        </el-card>
        <br />
        <el-card shadow="hover">
            <el-table v-loading="list.loading" :data="list.data">
                <el-table-column
                    label="角色名称"
                    prop="title"
                ></el-table-column>
                <el-table-column label="操作" min-width="160">
                    <template slot-scope="scope">
                        <el-button
                            size="mini"
                            @click="handleEditOrCreate(scope.$index, scope.row)"
                        >
                            编辑
                        </el-button>
                        <el-button
                            size="mini"
                            type="danger"
                            @click="handleDelete(scope.$index, scope.row)"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <br />
            <el-pagination
                :current-page="list.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="list.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="list.total"
            >
            </el-pagination>
        </el-card>

        <el-dialog :visible.sync="dialog.visible" :title="dialog.title">
            <el-form label-width="80px" :model="dialog.form">
                <el-form-item label="角色名称">
                    <el-input v-model="dialog.form.name" />
                </el-form-item>
                <el-form-item label-width="0px">
                    <el-table
                        v-loading="dialog.list.loading"
                        :data="dialog.list.dataTree"
                        row-key="id"
                        :tree-props="dialog.list.listProps"
                        :default-expand-all="true"
                        @selection-change="handleSelectionChange"
                        ref="table"
                    >
                        <el-table-column
                            type="selection"
                            width="55"
                            :selectable="isDisabled"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="title"
                            label="名称"
                        ></el-table-column>
                        <el-table-column
                            prop="name"
                            label="页面地址"
                        ></el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item style="text-align: right">
                    <el-button
                        type="primary"
                        style="width: 120px"
                        @click="handleUpload"
                    >
                        提交
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import {
    apiGetRoleList,
    apiGetAuthList,
    updateRoleInfo,
    deleteRole
} from "@/api/views/manager/role";

export default {
    name: "ManagerRole",
    data() {
        return {
            // 列表
            list: {
                // 列表加载状态
                loading: true,
                page: 1,
                size: 10,
                search: "",
                total: 0,
                data: []
            },

            /// 弹出层
            dialog: {
                // 弹出层状态
                visible: false,
                // 弹出层标题
                title: "",

                // 弹出层列表
                list: {
                    // 弹出层列表加载状态
                    loading: true,
                    // 弹出层列表
                    data: [],
                    // 弹出层列表树
                    dataTree: [],
                    listProps: {
                        children: "children"
                    },
                    // 选中项
                    multipleSelection: []
                },
                // 表单
                form: {
                    id: 0,
                    // 名称
                    name: "",
                    // id列表
                    idList: []
                }
            }
        };
    },
    created() {
        this.getRoleList();
    },
    methods: {
        // 获取角色列表
        getRoleList() {
            this.list.loading = true;
            apiGetRoleList({
                page: this.list.page,
                pagesize: this.list.size,
                search: this.list.search
            }).then(res => {
                this.list.total = parseInt(res.roleCount);
                this.list.data = res.roleList;
                this.list.loading = false;
            });
        },
        // 点击添加角色权限，显示弹出层
        handleEditOrCreate(index, row) {
            // 加载开始
            this.dialog.list.loading = true;

            // 重置一下列表树
            this.dialog.list.dataTree = [];
            apiGetAuthList().then(res => {
                let obj = {};
                const list = res.categorylist;
                // 缓存一下一维数组
                this.dialog.list.data = list;

                list.map(element => {
                    obj[element.id] = element;
                });
                list.forEach(item => {
                    const id = item.auth_pid;
                    if (id == 0) {
                        this.dialog.list.dataTree.push(item);
                    } else {
                        if (obj[id].children) {
                            obj[id].children.push(item);
                        } else {
                            obj[id].children = [item];
                        }
                    }
                });

                // 加载结束
                this.dialog.list.loading = false;

                if (row) {
                    this.dialog.form.idList = row.rules.split(",");
                    this.$nextTick(function() {
                        res.categorylist.forEach(item => {
                            if (
                                this.dialog.form.idList.indexOf(item.id) !== -1
                            ) {
                                this.$refs.table.toggleRowSelection(item, true);
                            }
                        });
                    });
                    this.dialog.form.id = row.id;
                    this.dialog.form.name = row.title;
                    // 编辑
                    this.dialog.title = "修改角色";
                } else {
                    // this.resertInfoForm();
                    // 添加
                    this.dialog.title = "添加角色";
                }
                // 显示添加角色弹出层
                this.dialog.visible = true;
            });
        },
        // 点击删除角色
        handleDelete(index, row) {
            deleteRole({
                roleid: row.id
            }).then(() => {
                this.getRoleList();
            });
        },
        // 弹出层选择更改
        handleSelectionChange(val) {
            this.dialog.list.multipleSelection = val;
        },
        // 树节点如果有子元素的话不可以选择
        isDisabled(row) {
            return row.children ? false : true;
        },
        // 弹出层点击确定提交
        handleUpload() {
            this.dialog.form.idList = [];
            this.dialog.list.multipleSelection.forEach(item => {
                this.dialog.form.idList.push(item.id);
            });
            updateRoleInfo({
                roleid: this.dialog.form.id,
                role_name: this.dialog.form.name,
                rolestr: this.dialog.form.idList.join(",")
            }).then(() => {
                this.dialog.visible = false;
                this.getRoleList();
            });
        }
    }
};
</script>

<style lang="scss" scoped>
/* 要用魔法对抗魔法，element的table全选在树模式下不好用，禁用全选 */
/deep/ .el-table__header-wrapper .el-checkbox {
    display: none;
}
</style>
